import css from '@styled-system/css';
import styled from 'styled-components';
import { color, compose, space, typography, } from 'styled-system';
import ListItem from './ListItem';
import theme from '../theme';
const MenuItem = styled(ListItem) `
  :hover {
    ${css({
    bg: 'gray.6',
})}
  }
  ${compose(color, space, typography)}
`;
MenuItem.defaultProps = { theme };
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map